import DefenceEveryDay from './views/defenceEveryDay';
export default DefenceEveryDay;
